module.exports = __webpack_public_path__ + "img/cloud-download 1.b584cf7c.svg";